import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import first from '../../assets/first.png';
import second from '../../assets/second.png';
import third from '../../assets/third.png';
import { Link, useHistory } from 'react-router-dom';
import { auth } from "../../firebase";
import Landing from '../pages/Landing';
// import './firstmodal.css';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';

function First({setgoToSecond}) {
    const uid = auth.currentUser.uid;
    const history = useHistory();
    if(localStorage.getItem('allowed')==='0'){
      window.location.href = '/home';
    }
    const [show, setShow] = useState(false);
    useEffect(() => {
        setShow(true);
    }, [])
    const handleClose = () => {
      localStorage.setItem('signup', '0');
      localStorage.setItem(uid, 'secondtime');
      setShow(false);
    };
    const [pos, setpos] = useState(1);
    const move = () =>{
      if(pos===3){
        handleClose();
      }
      else{
        if(pos===1){
          setpos(2);
        }
        else{
          setpos(3);
        }
      }
    }
    if(pos===1){
      return (
        <>

          <Modal
            className='modalc'
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}
          >
            <Modal.Body>
              <img src={first} className='image'/>
              <br/>
              <FiberManualRecordIcon className='icon1'/>
              <FiberManualRecordIcon className='icon2' color='disabled'/>
              <FiberManualRecordIcon className='icon3' color='disabled'/>
              <Link><Button className='button' onClick={move} variant="outline-dark">Next</Button></Link>
            </Modal.Body>
          </Modal>
        </>
      );
    }
  else if(pos===2){
    return (
      <>

        <Modal
          className='modalc'
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <img src={second} className='image'/>
            <br/>
            <FiberManualRecordIcon className='icon1' color='disabled'/>
            <FiberManualRecordIcon className='icon2'/>
            <FiberManualRecordIcon className='icon3' color='disabled'/>
            <Link><Button className='button' onClick={move} variant="outline-dark">Next</Button></Link>
          </Modal.Body>
        </Modal>
      </>
    );
  }
  else{
    return (
      <>

        <Modal
          className='modalc'
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Body>
            <img src={third} className='image'/>
            <br/>
            <FiberManualRecordIcon className='icon1' color='disabled'/>
            <FiberManualRecordIcon className='icon2' color='disabled'/>
            <FiberManualRecordIcon className='icon3'/>
            <Link><Button className='button' onClick={move} variant="outline-dark">Let's Go</Button></Link>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

export default First;